import { render, staticRenderFns } from "./LoansReportingPageView.vue?vue&type=template&id=d304ce9a&"
import script from "./LoansReportingPageView.vue?vue&type=script&lang=js&"
export * from "./LoansReportingPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports